import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ComponentComponent } from './component/component.component';
import { DashboardComponent } from './component/dashboard/dashboard.component';
import { LoginBaseComponent } from './login/login-base/login-base.component';
import { ChangePasswordComponent } from './login/change-password/change-password.component';
import { ShortformComponent } from './component/shortform/shortform.component';
import { ProfileComponent } from './login/profile/profile.component';
import { AuthGuard } from './service/auth.guard';
import { MenuGuard } from './service/menu.guard';
import { AccessGuard } from './service/access.guard';
import { SubmenuGuard } from './service/submenu.guard';
import { ContactComponent } from './login/contact/contact.component';
import { RacLifeCycleComponent } from './component/enit/AuditTrail/rac-life-cycle/rac-life-cycle.component';

const routes: Routes = [
  {
    path: 'login', component: LoginBaseComponent,
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },
  {
    path: '', component: ComponentComponent, canActivate: [AuthGuard],
    children: [
      { path: '', component: DashboardComponent },
      {
        path: 'form', component: ShortformComponent,
        children: [{ path: 'changepassword', component: ChangePasswordComponent },
        { path: 'profile', component: ProfileComponent },
        { path: 'contact', component: ContactComponent }]
      },
      {
        path: 'admin', canActivate: [MenuGuard, AccessGuard],
        children: [{ path: 'userlist', canDeactivate: [SubmenuGuard], loadChildren: () => import('./component/usermanagement/usermanagement.module').then(m => m.UsermanagementModule) },
        { path: 'useraccess', canDeactivate: [SubmenuGuard], loadChildren: () => import('./component/accessmanagement/accessmanagement.module').then(m => m.AccessmanagementModule) }]
      },
      { path: 'menu', loadChildren: () => import('./component/menumanagement/menumanagement.module').then(m => m.MenumanagementModule) },
      { path: 'role', loadChildren: () => import('./component/rolemanagement/rolemanagement.module').then(m => m.RolemanagementModule) },
      { path: 'eTrade', canActivate: [MenuGuard, AccessGuard], loadChildren: () => import('./component/enit/eTrade-routing.module').then(m=>m.EnitRoutingModule)},
      { path: 'tradeAdmin', canActivate: [MenuGuard, AccessGuard], loadChildren: () => import('./component/enit/tradeAdmin-routing.module').then(m=>m.TradeAdminRoutingModule)},
      { path: 'eCompliance', canActivate: [MenuGuard, AccessGuard], loadChildren: () => import('./component/enit/eComplaince-routing.module').then(m=>m.EnitComplainceRoutingModule)},
      { path: 'complianceAdmin', canActivate: [MenuGuard, AccessGuard], loadChildren: () => import('./component/enit/complainceAdmin-routing.module').then(m=>m.ComplainceAdminRoutingModule)},
      { path: 'racLifeCycle', component: RacLifeCycleComponent, canActivate: [AuthGuard],
        children: [
          { path: 'tradeAdmin', loadChildren: () => import('./component/enit/tradeAdmin-routing.module').then(m => m.TradeAdminRoutingModule) },
        ]
      },
    ]
  },
  { path: '**', redirectTo: '', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
  providers: [AuthGuard, MenuGuard, SubmenuGuard, AccessGuard]
})
export class AppRoutingModule {

}
